import { render, staticRenderFns } from "./msw-app-main.vue?vue&type=template&id=477a3334&"
import script from "./msw-app-main.vue?vue&type=script&lang=ts&"
export * from "./msw-app-main.vue?vue&type=script&lang=ts&"
import style0 from "./msw-app-main.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports